import { toast } from "@base/ui";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef } from "react";
import { useConexaoKommo } from "../application/conexoes.contexto";

/**
 * Toast enquanto o Kommo do cliente selecionado sincroniza, em qualquer tela:
 * "carregando" durante, e sucesso ou erro ao terminar. Ao terminar, os numeros
 * do Dashboard sao buscados de novo. Nao renderiza nada.
 */
export function AvisoDeSincronizacao({ clienteId }: { readonly clienteId: string }) {
  const { data } = useConexaoKommo(clienteId);
  const cliente = useQueryClient();
  const anterior = useRef<string | undefined>(undefined);
  const situacao = data?.situacao;
  const ultimoErro = data?.ultimoErro ?? null;
  const id = `sincronizacao-kommo:${clienteId}`;

  useEffect(() => {
    if (situacao === "sincronizando") {
      toast.loading("Sincronizando com o Kommo…", {
        id,
        description: "Os números do Dashboard são atualizados assim que terminar.",
        duration: Number.POSITIVE_INFINITY,
      });
    } else if (anterior.current === "sincronizando") {
      if (situacao === "com-erro") {
        toast.error("A sincronização com o Kommo falhou", {
          id,
          description: ultimoErro ?? "Tente de novo em alguns minutos.",
          duration: 8_000,
        });
      } else if (situacao === "conectada") {
        toast.success("Kommo sincronizado", {
          id,
          description: "Os números do Dashboard já estão atualizados.",
          duration: 4_000,
        });
        void cliente.invalidateQueries({ queryKey: ["dashboard", clienteId] });
      } else {
        toast.dismiss(id);
      }
    }
    anterior.current = situacao;
  }, [situacao, ultimoErro, id, clienteId, cliente]);

  // Trocar de cliente tira o aviso do anterior da tela.
  useEffect(() => () => void toast.dismiss(id), [id]);

  return null;
}
